import api from "@/service/api";
import { $t } from "@/i18n";
export default {
  namespaced: true,
  state: () => ({
    baseInfo: {
      tvl: "0",
      usdtTvl: "0",
      fxTvl: "0",
      totalVolume: "0",
      totalLiquidation: "0",
      totalFees: "0",
    },
    active: "", // BTC:USDT
    liquidationMarginData: {
      long: "0",
      short: "0",
    },
    liquidationMarginTotal: {
      value: "0",
      unit: "USDT",
    },
    temperatureGaugeChartSum: "0",
    inflowOutflowChartData: [
      {
        value: "0",
        name: $t(
          "dashboard.coreData.pairMetrics.inflowOutflowChartData.inflow"
        ),
        itemStyle: {
          color: "#18EED8",
        },
        tooltip: {
          show: false,
        },
        label: { show: true },
      },
      {
        value: "0",
        name: $t(
          "dashboard.coreData.pairMetrics.inflowOutflowChartData.outflow"
        ),
        itemStyle: {
          color: "#FF4196",
        },
        tooltip: {
          show: false,
        },
        label: { show: true },
      },
    ],
    proportionFundChartData: [
      {
        value: "0",
        name: $t("dashboard.coreData.pairMetrics.inflowOutflowChartData.big"),
        label: {
          show: false,
        },
        itemStyle: {
          color: "#fdc800",
        },
      },
      {
        value: "0",
        name: $t(
          "dashboard.coreData.pairMetrics.inflowOutflowChartData.medium"
        ),
        label: {
          show: false,
        },
        itemStyle: {
          color: "#a6f616",
        },
      },
      {
        value: "0",
        name: $t("dashboard.coreData.pairMetrics.inflowOutflowChartData.small"),
        label: {
          show: false,
        },
        itemStyle: {
          color: "#005fff",
        },
      },
    ],
  }),
  mutations: {
    SET_SELECT_ACTIVE(state, opt) {
      if (opt) state.active = opt;
    },
  },
  actions: {
    async getDashboardTokenData({ state }) {
      try {
        const {
          liquidationMargin,
          ibcInAndFlowDTO,
          proportionFundDTO,
          baseInfo,
        } = await api["getDashboardTokenData"]({
          pair: state.active,
        });
        state.baseInfo = baseInfo;
        state.liquidationMarginData.long = liquidationMargin.longMargin;
        state.liquidationMarginData.short = liquidationMargin.shortMargin;
        state.liquidationMarginTotal.value = liquidationMargin.totalMargin;

        state.inflowOutflowChartData[0].value = ibcInAndFlowDTO.ibcInflow;
        state.inflowOutflowChartData[1].value = ibcInAndFlowDTO.ibcOutflow;

        state.proportionFundChartData[0].value = proportionFundDTO.big;
        state.proportionFundChartData[1].value = proportionFundDTO.medium;
        state.proportionFundChartData[2].value = proportionFundDTO.small;
      } catch (error) {
        console.log(error);
      }
    },
  },
  getters: {},
};
